/* eslint-disable array-callback-return */
import React from 'react';
import CardE from '../Cards/CardE';
import CardE1 from '../Cards/CardE1';
import "./SectionStyles/Sections.css"

const SectionE = (props) => {
  const CardTheme = [
    {
      value: 2,

    }
  ];
  const cardData = [
    {
      id: 1987,
      name: 'Card 1',
      price: '250',
      img: 'https://www.kaybees.com.pk/_next/image?url=https%3A%2F%2Fassets.indolj.io%2Fimages%2F1652362090-american-cheese.jpg&w=256&q=75'
    },
    {
      id: 2654,
      name: 'CardE 2',
      price: '300',
      img: 'https://www.kaybees.com.pk/_next/image?url=https%3A%2F%2Fassets.indolj.io%2Fimages%2F1652266528-Raita.jpg&w=256&q=75'
    },
    {
      id: 3321,
      name: 'CardE 3',
      price: '400',
      img: 'https://www.kaybees.com.pk/_next/image?url=https%3A%2F%2Fassets.indolj.io%2Fimages%2F1652362090-american-cheese.jpg&w=256&q=75'
    },
    {
      id: 4098,
      name: 'CardE 4',
      price: '500',
      img: 'https://www.kaybees.com.pk/_next/image?url=https%3A%2F%2Fassets.indolj.io%2Fimages%2F1652266528-Raita.jpg&w=256&q=75'
    },
    {
      id: 5765,
      name: 'CardE 5',
      price: 'Rs.500',
      img: 'https://www.kaybees.com.pk/_next/image?url=https%3A%2F%2Fassets.indolj.io%2Fimages%2F1652362090-american-cheese.jpg&w=256&q=75'
    },
    {
      id: 6544,
      name: 'CardE 6',
      price: '500',
      img: 'https://www.kaybees.com.pk/_next/image?url=https%3A%2F%2Fassets.indolj.io%2Fimages%2F1652266528-Raita.jpg&w=256&q=75'
    },
    {
      id: 7321,
      name: 'CardE 7',
      price: '500',
      img: 'https://www.kaybees.com.pk/_next/image?url=https%3A%2F%2Fassets.indolj.io%2Fimages%2F1652362090-american-cheese.jpg&w=256&q=75'
    },
    {
      id: 8098,
      name: 'CardE 8',
      price: '800',
      img: 'https://www.kaybees.com.pk/_next/image?url=https%3A%2F%2Fassets.indolj.io%2Fimages%2F1652266528-Raita.jpg&w=256&q=75'
    },
  ];

  return (
    <>
      {CardTheme.map((theme) => {

        if (theme.value === 1) {
          return (
            <div id={props.id} key={theme.value} className='main-main'>
              <h1 >{props.Heading}</h1>
              <div className='main' >
                {cardData.map((data, id) => (
                  <CardE
                    key={id}
                    id={data.id}
                    name={data.name}
                    price={data.price}
                    img={data.img}
                  />
                ))}
              </div>
            </div>
          )
        }
        else if (theme.value === 2) {
          return (
            <div id={props.id} key={theme.value} className='main-main'>
              <h1 >{props.Heading}</h1>
              <div className='main' >
                {cardData.map((data, id) => (
                  <CardE1
                    key={id}
                    id={data.id}
                    name={data.name}
                    price={data.price}
                    img={data.img}
                  />
                ))}
              </div>
            </div>
          )
        }
      }
      )
      }
    </>
  )
}
SectionE.defaultProps = {
  Heading: "Section E",
  id:'sectionE'
}
export default SectionE
